var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-progress-bar local-hero"},[_c('div',{staticClass:"step-wrapper"},[_c('div',{staticClass:"step-number-text"},[_vm._v(" "+_vm._s(_vm.stepInfo)+" ")]),_c('div',{staticClass:"step-description-text"},[_vm._v(" "+_vm._s(_vm.description)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }